import { FunctionComponent, useState, KeyboardEvent, MouseEvent, memo } from 'react';
import { Box, Divider, Drawer, IconButton, Link } from '@material-ui/core';
import { CloseWhiteIcon, MenuBarIcon } from 'Components';
import './WelcomeDrawer.scss';
import { WelcomeLinks } from 'Views/Welcome/WelcomeLinks';
import { gutters } from 'Theme/Variables';
import { WelcomeHeaderMenuItemType } from '../WelcomeHeader';
import { useWindowDimensions } from 'Hooks';
import classNames from 'classnames';
import { IstanbulWhiteLogo } from 'Components';
import { useHistory, useLocation } from 'react-router-dom';
import { routePath } from 'Navigator/routes';
import { userStore } from 'Stores/User';
import { useSelector } from 'react-redux';

type WelcomeDrawerProps = {
  menuItems: WelcomeHeaderMenuItemType[];
  isDrawerLinks?: boolean;
};

const WelcomeDrawer: FunctionComponent<WelcomeDrawerProps> = memo(({ menuItems, isDrawerLinks }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { height, isTinyHeightDevice } = useWindowDimensions();
  const { pathname } = useLocation();
  const history = useHistory();
  const userData = useSelector(userStore);
  const isMiniApp = userData?.isMiniAppLogin;

  const toggleDrawer = (open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setIsOpen(open);
  };

  const handleDirectHomePage = () => {
    if (pathname === routePath.home) {
      window.location.reload();
    } else if (pathname === routePath.welcome) {
      window.location.reload();
    } else {
      history.push(routePath.home);
    }
  };

  return (
    <div id="welcomeDrawer">
      <IconButton aria-label="Menüyü aç" onClick={toggleDrawer(true)} className="welcomeDrawer-bar" size="small">
        <MenuBarIcon />
      </IconButton>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          className: classNames({
            'welcomeDrawer-drawer': true,
            'welcomeDrawer-drawer--smallHeightDevice': isTinyHeightDevice,
          }),
          style: {
            height: height,
          },
        }}
      >
        <Box padding={gutters.regular} justifyContent="center" display="flex" className="welcomeDrawer-drawer--logo">
          <IconButton aria-label="Ana sayfaya git" onClick={handleDirectHomePage} size="small" style={{ borderRadius: 4, padding: 4 }}>
            <IstanbulWhiteLogo width={125} />
          </IconButton>
        </Box>
        <IconButton
          aria-label="Menüyü kapat"
          onClick={toggleDrawer(false)}
          style={{position:'absolute' ,top:3, right:3}}
        >
          <CloseWhiteIcon className=""/>
        </IconButton>
        
        <Box
          paddingLeft={gutters.regular}
          paddingRight={gutters.regular}
          display="flex"
          flexDirection="column"
          height="100%"
        >
          <div className="welcomeDrawer-drawer--divider">
            <Divider />
          </div>

          <Box display="flex" flexDirection="column-reverse">
            {menuItems.map(({ title, onClick, Icon, itemID }, index) =>
              isMiniApp && itemID === 'navigateCardApplicationBtnTest' ? (
                ''
              ) : (
                <MenuItem
                  key={index}
                  title={title}
                  onClick={() => {
                    onClick();
                    setIsOpen(false);
                  }}
                  Icon={Icon && Icon}
                  itemID={itemID}
                />
              )
            )}
          </Box>
          <WelcomeLinks isDrawerLinks={isDrawerLinks} />
        </Box>
      </Drawer>
    </div>
  );
});

const MenuItem: FunctionComponent<WelcomeHeaderMenuItemType> = memo(({ title, onClick, Icon, itemID }) => (
  <>
    <Divider />
    <Box display="flex" paddingBottom={gutters.regular} paddingTop={gutters.regular}>
      {Icon && (
        <Box marginRight={gutters.regular} style={{ marginTop: '-2px' }} aria-hidden="true">
          <Icon />
        </Box>
      )}
      <Link
        component="button"
        type="button"
        underline="none"
        display="block"
        id={itemID}
        onClick={onClick}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          textAlign: 'left',
          fontFamily: 'inherit',
          color: 'inherit',
        }}
      >
        <Box fontWeight="bold">{title}</Box>
      </Link>
    </Box>
  </>
));

export default WelcomeDrawer;
